export default {
	loading  : false,
	frequency: []
}
